/*=========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
==========================================================================================*/


import state from './moduleEndorsementInviteState.js'
import mutations from './moduleEndorsementInviteMutations.js'
import actions from './moduleEndorsementInviteActions.js'
import getters from './moduleEndorsementInviteGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
